import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, auto));
  @media ${devices.desktopS} {
    grid-template-columns: repeat(3, minmax(0, auto));
  }
  @media ${devices.tablet} {
    grid-template-columns: repeat(2, minmax(0, auto));
  }
  @media ${devices.phoneL} {
    grid-template-columns: repeat(1, minmax(0, auto));
  }
`;

export const TableColumns = styled.div`
  margin: 5px;
  & h3 {
    margin: 0 0 5px 0;
    text-align: center;
    width: 100%;
  }
`;
